module.exports = __webpack_public_path__ + "img/2_x4.f89b83f0.png";